/**
 * Please note: If you add a feature id please export it individually and use lowercase so it can match to a feature flag in LaunchDarkly.
 */

export const FEATURE_ALLOW_REPLY = 'allow.reply';

export const FEATURE_ATTENDANCE_CUSTOMQUESTIONS = 'attendance.custom-questions';
export const FEATURE_ATTENDANCE_DISCLAIMERS = 'attendance.disclaimers';
export const FEATURE_ATTENDANCE_LIVE = 'feature.attendance.live';

export const FEATURE_BRAND_HUB = 'brand.hub';

export const FEATURE_BILLING_UPGRADE = 'billing.upgrade';
export const FEATURE_BILLING_UPGRADE_REQUEST = 'billing.upgrade.request';
export const FEATURE_BILLING_INVOICES = 'billing.invoices';
export const FEATURE_BILLING_PAYMENTDETAILS = 'billing.payment-details';
export const FEATURE_BILLING_MANAGEPLAN_STRIPE = 'billing.manage-plan.stripe';
export const FEATURE_BILLING_MANAGEPLAN_ADPRUN = 'billing.manage-plan.adprun';

export const FEATURE_CERTIFICATE = 'certificate';
export const FEATURE_CLOUD_STORAGE = 'cloud-storage';
export const FEATURE_CONNECTION = 'connection';
export const FEATURE_CONNECTION_COLUMN_CERTIFICATE =
    'connection.column.certificate';
export const FEATURE_CONNECTION_COMPLIANCE_CUSTOM =
    'connection.compliance.custom';

export const FEATURE_COMPLIANCE_BREAKS = 'compliance.breaks';
export const FEATURE_COMPLIANCE_OVERTIME = 'compliance.overtime';
export const FEATURE_COMPLIANCE_CUSTOM_RULEGROUP =
    'compliance.custom.rule-group';

export const FEATURE_DEMOMODE = 'demo-mode';
export const FEATURE_ORDER_OPTIONS = 'order.options';

export const FEATURE_EXPORT_ADPRUN = 'export.adprun';

export const FEATURE_INTEGRATION_POS = 'integration.pos';
export const FEATURE_INTEGRATION_MOBILEBYTES = 'integration.mobile-bytes';
export const FEATURE_INTEGRATION_PAYROLL = 'integration.payroll';
export const FEATURE_INTEGRATION_XERO = 'integration.xero';
export const FEATURE_INTEGRATION_CSV_PAYROLLUS = 'integration.csv.payroll-us';
export const FEATURE_INTEGRATION_CSV_ADPWORKFORCE =
    'integration.csv.adp-workforce';
export const FEATURE_INTEGRATION_CSV_COASTAL = 'integration.csv.coastal';

export const FEATURE_HIRING = 'feature.hiring';
export const FEATURE_HIRING_INIT = 'feature.hiring-init';
export const FEATURE_HIRINGCANDIDATES = 'feature.hiring-candidates';

export const FEATURE_LOCATION_ADD = 'location.add';
export const FEATURE_LOCATION_ADD_ADPRUN = 'location.add.adprun';

export const FEATURE_LOGBOOK = 'logbook';

export const FEATURE_OFF_SITE_ADDRESSES = 'off-site.addresses';

export const FEATURE_ORDERS = 'feature.orders';

export const FEATURE_PLAN = 'plan';

export const FEATURE_REPORTS_STARTER = 'reports.starter';
export const FEATURE_REPORTS_PREMIUM = 'reports.premium';
export const FEATURE_REPORTS_LABORVSSALES = 'reports.laborvssales';
export const FEATURE_REPORTS_TIPSVSSALES = 'reports.tipsvssales';
export const FEATURE_REPORTS_NOSHOW = 'reports.noshow';
export const FEATURE_REPORTS_CONTACT_TRACING = 'reports.contact-tracing';

export const FEATURE_ONBOARD = 'onboard';
export const FEATURE_ONBOARD_HEARTLAND = 'onboard.heartland';

export const FEATURE_SALES = 'sales';
export const FEATURE_SALES_IMPORT = 'sales.import';
export const FEATURE_SALES_VIEW = 'sales.view';
export const FEATURE_SAVE_PREFERENCE = 'preference.save';

export const FEATURE_SCHEDULE_ADD = 'schedule.add';
export const FEATURE_SCHEDULE_SECTIONS = 'schedule.sections';
export const FEATURE_SCHEDULE_SYNC = 'schedule.sync';

export const FEATURE_SCHEDULER_ADD_TIMEOFF = 'scheduler.add-timeoff';
export const FEATURE_SCHEDULER_DAY_VIEW = 'scheduler.day-view';
export const FEATURE_SCHEDULER_BUDGET = 'scheduler.budget';
export const FEATURE_SCHEDULER_MANAGE = 'scheduler.manage';

export const FEATURE_ORDER_SYNC = 'order.sync';

export const FEATURE_TIMECARDS_EXPORT = 'timecards.export';
export const FEATURE_TIMECARDS_STATUS = 'timecards.status';

export const FEATURE_TIMEOFF = 'time-off';
export const FEATURE_TIMEOFFS_EXPORT = 'time-offs.export';
export const FEATURE_TIMEOFF_BLOCK = 'time-off.block';

export const FEATURE_TIMECLOCK_SETTINGS = 'timeclock.settings';
export const FEATURE_TIMECLOCK_NOTIFICATIONS = 'timeclock.notifications';

export const FEATURE_WORKER_PROFILE_AVAILABILITY =
    'Worker.Profile.Availability';
export const FEATURE_WORKER_PROFILE_AVAILABILITY_ROUTE =
    'Worker.Profile.Availability.Route';

// TODO: These constants should be exported individually to support tree shaking

export const FEATURE = {
    ADMIN_UPGRADE_PREMIUM: 'Admin.UpgradePremium',
    PROFILE_EDIT: 'Profile.Edit',
    PROFILE_RECOMMENDATION_DELETE: 'Profile.Recommendation.Delete',
    PROFILE_ACCOUNT_SETTINGS: 'Profile.Account.Settings',
    PROFILE_LOCATIONS_ADD: 'Profile.Locations.Add',
    POSITION_RATE: 'Position.Rate',
    WORKER_PROFILE_ACCESS_LEVEL: 'Worker.Profile.AccessLevel',
    WORKER_PROFILE_EDIT: 'Worker.Profile.Edit',
    WORKER_PROFILE_CERTIFICATIONS_EDIT: 'Worker.Profile.Certifications.Edit',
    WORKER_PROFILE_RATE: 'Worker.Profile.Rate',
    MANAGE_WORKERS_ASSIGN_MANAGERS: 'ManageWorkers.AssignManagers',
    SCHEDULES_ALL: 'Schedules.All',
    SCHEDULES_LIST: 'Schedules.List',
    SCHEDULER_CREATE_SCHEDULE: 'Scheduler.CreateSchedule',
    SCHEDULER_BUDGET: 'Scheduler.Budget',
    SCHEDULER_SETTINGS: 'Scheduler.Settings',
    SUPPORT: 'Support',
    LOCATIONS: 'Locations',
    LOCATIONS_ALL: 'Locations.All',
    LOCATIONS_DELETE: 'Locations.Delete',
    LOCATIONS_SCHEDULES: 'Locations.Schedules',
    LOGBOOKS: 'Logbooks',
    LOGBOOKS_POST_DELETE: 'Logbooks.Post.Delete',
    TIMEOFF_DELETE: 'Timeoff.Delete',
    ATTENDANCE: 'Attendance.Feature',
    ATTENDANCE_COMPLIANCE: 'Attendance.Compliance',
    ATTENDANCE_HOLIDAYS: 'Attendance.Holidays',
    ATTENDANCE_REPORTS: 'Attendance.Reports',
    ATTENDANCE_UPGRADE: 'Attendance.Upgrade',
    ATTENDANCE_ADMIN_ONLY: 'Attendance.Feature.Admin',
    ATTENDANCE_TRIAL: 'Attendance.Trial',
    ATTENDANCE_BUDGET: 'Attendance.Budget',
    ATTENDANCE_TIMECARDS: 'Attendance.Timecards',
    ATTENDANCE_PAYROLLS: 'Attendance.Feature.Payroll',
    ATTENDANCE_TIMECLOCK: 'Attendance.Feature.Timeclock',
    ATTENDANCE_TIMECLOCK_ADMIN: 'Attendance.Feature.Timeclock.Admin',
    ATTENDANCE_TIMECLOCK_VIEW: 'Attendance.Feature.Timeclock.View',
    ATTENDANCE_SETTINGS: 'Attendance.Feature.Settings',
    BILLING: 'Billing',
    BILLING_ALERT: 'Billing.Alert',
    BILLING_BILLINGANDPAYMENTS: 'Billing.BillingAndPayments',
    CONNECTION: 'Connection.Feature',
    CONNECTION_CREATE: 'Connection.Create',
    CONNECTION_EDIT: 'Connection.Edit',
    CONNECTION_PERMISSIONS_CERTIFICATIONS:
        'Connection.Permissions.Certifications',
    CONNECTION_PERMISSIONS_TIMECARDS: 'Connection.Permissions.Timecards',
    CONNECTION_PERMISSIONS_TIMECLOCKS: 'Connection.Permissions.Timeclocks',
    CONNECTIONS_FILTER_CERTIFICATIONS: 'Connections.Filter.Certifications',
    CERTIFICATE: 'Certificate',
    COMPANY_ADMIN: 'Company.Admin',
    REPORTS: 'Reports',
    SETUP_GUIDE_SCHEDULING_ESSENTIALS: 'SetupGuide.SchedulingEssentials',
    SETUP_GUIDE_SCHEDULING_ESSENTIALS_ASSIGN_MANAGER:
        'SetupGuide.SchedulingEssentials.AssignManager',
    SETUP_GUIDE_SCHEDULING_ESSENTIALS_CONFIGURE_SCHEDULE:
        'SetupGuide.SchedulingEssentials.ConfigureSchedule',
    SETUP_GUIDE_SET_COMPANY_ACCOUNT: 'SetupGuide.SetCompanyAccount',
    SETUP_GUIDE_SET_COMPANY_ACCOUNT_NEW_LOCATION:
        'SetupGuide.SetCompanyAccount.NewLocation',
    SETUP_GUIDE_SET_COMPANY_ACCOUNT_NEW_SCHEDULE:
        'SetupGuide.SetCompanyAccount.NewSchedule',
    SETUP_GUIDE_ONBOARD_WORKERS: 'SetupGuide.OnboardWorkers',
    SETUP_GUIDE_POWER_FEATURES: 'SetupGuide.PowerFeatures',
    SETUP_GUIDE_POWER_FEATURES_SET_BUDGET: 'SetupGuide.PowerFeatures.SetBudget',
    SETUP_GUIDE_ATTENDANCE_TIME_CLOCK_ESSENTIALS:
        'SetupGuide.Attendance.TimeClockEssentials',
    SETUP_GUIDE_ATTENDANCE_MANAGEMENT_APPROVE_TIMECARD:
        'SetupGuide.Attendance.TimecardAndPayrollManagement.ApproveTimecard',
    SETUP_GUIDE_ATTENDANCE_MANAGEMENT_BULK_APPROVE:
        'SetupGuide.Attendance.TimecardAndPayrollManagement.BulkAproveTimecards',
    SETUP_GUIDE_ATTENDANCE_MANAGEMENT_SEND_FOR_APPROVAL:
        'SetupGuide.Attendance.TimecardAndPayrollManagement.SendTimecardForApproval',
    SETUP_GUIDE_ATTENDANCE_MANAGEMENT_EDIT_TIMECARD:
        'SetupGuide.Attendance.TimecardAndPayrollManagement.EditTimecard',
    SETUP_GUIDE_ATTENDANCE_MANAGEMENT_CREATE_TIMECARD:
        'SetupGuide.Attendance.TimecardAndPayrollManagement.CreateTimecard',
    SETUP_GUIDE_ATTENDANCE_MANAGEMENT_PAYROLL_CLOSE_EXPORT:
        'SetupGuide.Attendance.TimecardAndPayrollManagement.PayrollCloseAndExport',
    SETUP_GUIDE_ATTENDANCE_MANAGEMENT_PAYROLL_HISTORY:
        'SetupGuide.Attendance.TimecardAndPayrollManagement.PayrollHistory',
    SETUP_GUIDE_ATTENDANCE_COMPLIANCE: 'SetupGuide.Attendance.Compliance',
    SETUP_GUIDE_ATTENDANCE_COMPLIANCE_VIEW_WARNINGS:
        'SetupGuide.Attendance.Compliance.ViewWarnings',
    SETUP_GUIDE_ATTENDANCE_COMPLIANCE_VIEW_CERTIFICATIONS:
        'SetupGuide.Attendance.Compliance.ViewCertifications',
    SUBSCRIBE: 'Subscribe',
    TRIAL_COUNTDOWN: 'Trial.Countdown',
    UPGRADE_TRY_PREMIUM: 'Upgrade.TryPremium',
    UPGRADE_FROM_TRIAL: 'Upgrade.FromTrial',
    UPGRADE: 'Upgrade',
};
